<!-- <app-error-modal (resetErrorModal) = resetErrorModal($event)   [isErrorModalShown]=isErrorModalShown [error_msg]=error_msg></app-error-modal> -->

<!-- confirm modal for post delete start-->
<app-confirm-modal *ngIf="isConfirmModalShown==true" (resetConfirmModal)=resetConfirmModal($event) [isConfirmModalShown]=isConfirmModalShown [confirmInfo]=confirmInfo></app-confirm-modal>
